<template>
  <div>
    <h3>SurveyAnswer</h3>
  </div>
</template>

<script>
export default {
  name: 'SurveyAnswer',

};
</script>

<style scoped>
</style>
